export var ERegistrationDocumentStatus;
(function (ERegistrationDocumentStatus) {
    ERegistrationDocumentStatus["None"] = "none";
    ERegistrationDocumentStatus["Registering"] = "registering";
    ERegistrationDocumentStatus["Registered"] = "registered";
    ERegistrationDocumentStatus["RegisteredManually"] = "registered-manually";
    ERegistrationDocumentStatus["Incomplete"] = "incomplete";
    ERegistrationDocumentStatus["NeedPayment"] = "need-payment";
    ERegistrationDocumentStatus["NotApplicable"] = "not-applicable";
    ERegistrationDocumentStatus["Rejected"] = "rejected";
    ERegistrationDocumentStatus["Failed"] = "failed";
})(ERegistrationDocumentStatus || (ERegistrationDocumentStatus = {}));
export var ERegistrationBrusselsStatus;
(function (ERegistrationBrusselsStatus) {
    ERegistrationBrusselsStatus["None"] = "none";
    ERegistrationBrusselsStatus["Registering"] = "registering";
    ERegistrationBrusselsStatus["Registered"] = "registered";
    ERegistrationBrusselsStatus["RegisteredManually"] = "registered-manually";
    ERegistrationBrusselsStatus["Failed"] = "failed";
})(ERegistrationBrusselsStatus || (ERegistrationBrusselsStatus = {}));
export var ERegistrationFailedReason;
(function (ERegistrationFailedReason) {
    ERegistrationFailedReason["AddressNotFound"] = "ADDRESS_NOT_FOUND";
})(ERegistrationFailedReason || (ERegistrationFailedReason = {}));
export var ERegistrationContractDestination;
(function (ERegistrationContractDestination) {
    ERegistrationContractDestination["Housing"] = "housing";
    ERegistrationContractDestination["Commercial"] = "commercial";
    ERegistrationContractDestination["Mixed"] = "mixed";
    ERegistrationContractDestination["Farm"] = "farm";
    ERegistrationContractDestination["HuntingAndFishing"] = "hunting and fishing";
    ERegistrationContractDestination["Special"] = "special";
    ERegistrationContractDestination["Common"] = "common";
})(ERegistrationContractDestination || (ERegistrationContractDestination = {}));
export var ERegistrationContractType;
(function (ERegistrationContractType) {
    ERegistrationContractType["Lease"] = "lease";
    ERegistrationContractType["Amendment"] = "amendment";
    ERegistrationContractType["Sublease"] = "sublease";
    ERegistrationContractType["Cession"] = "cession";
    ERegistrationContractType["Termination"] = "termination";
})(ERegistrationContractType || (ERegistrationContractType = {}));
export var ERegistrationMemberType;
(function (ERegistrationMemberType) {
    ERegistrationMemberType["Owner"] = "OWNER";
    ERegistrationMemberType["Broker"] = "BROKER";
    ERegistrationMemberType["Tenant"] = "TENANT";
})(ERegistrationMemberType || (ERegistrationMemberType = {}));
export var ERegistrationDocumentType;
(function (ERegistrationDocumentType) {
    ERegistrationDocumentType["Contract"] = "Contract";
    ERegistrationDocumentType["PropertyInspectionReport"] = "PropertyInspectionReport";
    ERegistrationDocumentType["Addendum"] = "Addendum";
    ERegistrationDocumentType["Brussels"] = "Brussels";
})(ERegistrationDocumentType || (ERegistrationDocumentType = {}));
export var ERegistrationContractLanguage;
(function (ERegistrationContractLanguage) {
    ERegistrationContractLanguage["Dutch"] = "nl";
    // English = "en",
    ERegistrationContractLanguage["French"] = "fr";
})(ERegistrationContractLanguage || (ERegistrationContractLanguage = {}));
